import { Action, createReducer, on } from '@ngrx/store';
import { UserDto } from 'src/api/models';
import * as userActions from './actions';

export const initialUserState: Partial<UserDto> = {};

export const userReducer = createReducer(
  initialUserState,
  on(userActions.SetUser, (_, { user }) => user),
);

export function reducers(state: UserDto | undefined, action: Action): Partial<UserDto> {
  return userReducer(state, action);
}
